import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { PlatformPage } from "@/landing/components/PlatformPage";
import { PLATFORM_REDIRECTS } from "@/landing/lib/platform-copy";
import { getPlatformCopy } from "@/landing/lib/platform-i18n";
import { platformHead } from "@/landing/lib/platform-meta";

export const Route = createFileRoute("/_landing/platform/$slug")({
  loader: ({ params }) => {
    // Server requests are redirected by server/middleware/platform-redirect.ts;
    // this covers client-side navigation to a cut page.
    if (Object.hasOwn(PLATFORM_REDIRECTS, params.slug))
      throw redirect({
        href: PLATFORM_REDIRECTS[params.slug],
        statusCode: 301,
      });
    const copy = getPlatformCopy("en", params.slug);
    if (!copy) throw notFound();
    return { copy };
  },
  head: ({ loaderData }) =>
    loaderData ? platformHead(loaderData.copy, "en") : {},
  component: PlatformPageRoute,
});

function PlatformPageRoute() {
  const { copy } = Route.useLoaderData();
  return <PlatformPage key={copy.slug} copy={copy} locale="en" />;
}
